import axios from "axios";
import { Config } from "../Common/Config";
import { pushTraceLogEvent } from "../BookingJourney/StepComponents/sessionEventPush";

export const spacerData = async (apiName, payload, url, isProtected = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      // console.log('spacerData ::::', payload)
      // const response = await axios.get(`${Config.url}${apiName}`,{data : payload}, {
      //     headers: {
      //         'Content-Type': 'application/json',
      //         'Authorization': `Bearer ${localStorage.getItem('token')}`
      //     }
      // });

      const baseUrl = isProtected ? Config.url : Config.urlOpen;
      // console.log('Open API URL:', Config.urlOpen);
      // Build headers conditionally
      const headers = {
        "Content-Type": "application/json",
        ...(isProtected && {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }),
      };

      const response = await axios.get(`${baseUrl}${apiName}`, {
        headers,
        params: payload, // Correct for GET requests
      });

      // const response = await axios.get(`${Config.url}${apiName}`, {
      //     headers: {
      //       'Content-Type': 'application/json',
      //       'Authorization': `Bearer ${localStorage.getItem('token')}`
      //     },
      //     params: payload // ← Use this instead of `data` for GET
      //   });

      resolve(response);
    } catch (error) {
      pushTraceLogEvent({
        event: `${apiName} fetch failed`,
        payload: {
          message: `error in ${apiName} API call`,
          error,
        },
        step_status: "failed",
      });
      console.log(`error in ${apiName} API call`, error);
      resolve(error);
    }
  });
};

export const genericApiCall = async (
  apiName,
  payload,
  url,
  isProtected = true,
) => {
  return new Promise(async (resolve, reject) => {
    try {
      const baseUrl = isProtected ? Config.url : Config.urlOpen;

      const response = await axios.post(
        `${baseUrl}${apiName}`,
        {
          ...payload,
        },
        {
          headers: {
            "Content-Type": "application/json",
            ...(isProtected && {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            }),
          },
        },
      );
      const res = await response.data;
      if (res?.success) {
        resolve(response);
      } else if (!res?.success) {
        resolve(response);
        return;
      }
      if (response) {
        // getAlllunchAndSpacerData(1)
        resolve(response);
      }
    } catch (error) {
      pushTraceLogEvent({
        event: `${apiName} fetch failed`,
        payload: {
          message: "error in get clinic data ::::",
          error,
        },
        step_status: "failed",
      });
      resolve([]);
    }
  });
};
